var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stream-editor-editor-panel",class:{'stream-editor-editor-panel--loading': _vm.loading},style:(_vm.style)},[_c('workarea',[_c('div',{staticClass:"stream-editor-editor-panel__container",class:_vm.containerSize},[_c('workarea-components')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }